
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiYaw as ObiYawElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-yaw.js';
 
 
 

 
 export const ObiYaw = createComponent({
   react: React,
   tagName: 'obi-yaw',
   elementClass: ObiYawElement,
   events: {
     
   }
  });
 
 